import BaseApi from './baseApi'
import storeId from './_storeId'

export default class PaymentToStoreBook extends BaseApi {
  uri = `/api/v1/stores/${storeId()}/books/payment-to-store`
}
